(() => {
  const blockSelector = "[id*='frengee_app_product_specifications']";
  const tableSelector = '.frengee-specs-table';
  let blockObserver;
  let observedBlock;
  let updateFrame;

  function addSpecificationsHeader(block) {
    block.querySelectorAll(tableSelector).forEach((table) => {
      if (table.tHead || table.dataset.bikeLineHeader === 'true') return;

      const head = table.createTHead();
      const row = head.insertRow();

      ['Specification', 'Details'].forEach((label) => {
        const heading = document.createElement('th');
        heading.scope = 'col';
        heading.textContent = label;
        row.appendChild(heading);
      });

      table.dataset.bikeLineHeader = 'true';
    });
  }

  function scheduleHeaderUpdate() {
    if (!observedBlock || updateFrame) return;

    updateFrame = requestAnimationFrame(() => {
      updateFrame = null;
      addSpecificationsHeader(observedBlock);
    });
  }

  function connectToSpecificationsBlock() {
    const block = document.querySelector(blockSelector);

    if (!block || block === observedBlock) return;

    blockObserver?.disconnect();
    observedBlock = block;
    addSpecificationsHeader(block);

    blockObserver = new MutationObserver(scheduleHeaderUpdate);
    blockObserver.observe(block, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connectToSpecificationsBlock, {
      once: true,
    });
  } else {
    connectToSpecificationsBlock();
  }

  document.addEventListener('shopify:section:load', connectToSpecificationsBlock);
})();
